var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.924,
    height: 20,
    viewBox: "0 0 17.924 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "About_Us",
    "data-name": "About Us",
    transform: "translate(-442.144 -8.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20885",
    "data-name": "Path 20885",
    d: "M446.856,510.759a22.573,22.573,0,0,1-4.281-.426,15.309,15.309,0,0,1-3.092-.939,6.326,6.326,0,0,1-.86-.434.931.931,0,0,1-.477-.908,10.74,10.74,0,0,1,.373-2.364,5.38,5.38,0,0,1,1.315-2.376,4.973,4.973,0,0,1,2.6-1.459,1.764,1.764,0,0,1,1.234.178,6.866,6.866,0,0,0,2.923.816,7.637,7.637,0,0,0,3.33-.5,3.624,3.624,0,0,0,.649-.3,1.542,1.542,0,0,1,1.231-.183,5.017,5.017,0,0,1,3.6,2.985,8.734,8.734,0,0,1,.666,3.331.887.887,0,0,1-.483.786,8.776,8.776,0,0,1-1.694.761,18.92,18.92,0,0,1-4.7.95C448.5,510.731,447.8,510.76,446.856,510.759Zm.107-1.528a25.653,25.653,0,0,0,2.66-.128,17.212,17.212,0,0,0,3.2-.613,6.883,6.883,0,0,0,1.193-.45.642.642,0,0,0,.384-.659,5.51,5.51,0,0,0-.743-2.454,2.986,2.986,0,0,0-2.187-1.553,1.508,1.508,0,0,0-.872.066,9.424,9.424,0,0,1-3,.683,7.67,7.67,0,0,1-2-.13,7.1,7.1,0,0,1-1.844-.5,1.763,1.763,0,0,0-1.018-.126,2.808,2.808,0,0,0-1.739.957,4.895,4.895,0,0,0-.773,1.331,5.216,5.216,0,0,0-.4,1.874.416.416,0,0,0,.087.261.784.784,0,0,0,.327.264,10.645,10.645,0,0,0,2.107.68A21.389,21.389,0,0,0,446.963,509.231Z",
    transform: "translate(4 -481.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20886",
    "data-name": "Path 20886",
    d: "M608.648,14.115a5.142,5.142,0,1,1,5.132,5.141A5.143,5.143,0,0,1,608.648,14.115Zm1.429,0a3.713,3.713,0,1,0,3.728-3.7A3.71,3.71,0,0,0,610.077,14.115Z",
    transform: "translate(-162.681)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon2);
export default __webpack_public_path__ + "static/media/sidebar_icon2.f1d0110ecec323505319a1983108b607.svg";
export { ForwardRef as ReactComponent };